/**
 * Created by Zhaoyp 20250728
 */

import * as _ from 'lodash-es';

import { produce } from "immer";
import {createStore} from "@core/mgx";
import {all, call, fork, get, put, take} from "@core/mgx/saga";

import {
    ACTION_CATEGORY,
    UPLOAD_LIST_FIN, _UPLOAD_LIST,
    UPLOAD_PARTIAL, _UPLOAD_PARTIAL, _UPLOAD_PARTIAL_FIN, UPLOAD_PARTIAL_FIN,
} from "@/actions/onboardAction";
import API from "@/utils/APIOnboarding";


const LEGAL_CATEGORIES = [ACTION_CATEGORY];

let _INIT_STATE = {
    uploading: false,
    partialUploading: false,
    lastSummary: null, // { insertedCount, totalCount, failedCount, errors }
};

function* _uploadListFile() {
	while (true) {
		const action = yield take(_UPLOAD_LIST);
        if(action.file){
            const res = yield call(API.uploadListFile, {file: action.file});
            yield put(UPLOAD_LIST_FIN({data: res}));
        }
	}
}

function* _uploadPartial() {
    while(true){
        const action = yield take(_UPLOAD_PARTIAL);
        const rows = action.rows || (action.data && action.data.rows);
        if(rows && rows.length){
            const res = yield call(API.partialUpload, {rows});
            yield put(UPLOAD_PARTIAL_FIN({data: res}));
        } else {
            yield put(UPLOAD_PARTIAL_FIN({data: { r: 1, error: 'NoRows', message: 'No valid rows to upload' }}));
        }
    }
}

const _processor = produce((draftState, action) => {
	const {type, data} = action;
    // console.log(type, action);
	switch (type) {
        case _UPLOAD_PARTIAL:
            draftState.partialUploading = true;
            break;
        case _UPLOAD_PARTIAL_FIN:
            draftState.partialUploading = false;
            if(data){
                draftState.lastSummary = data;
            }
            break;
        default:
            break;
	}
	return draftState;
});

const store = createStore(_INIT_STATE, _processor, {
	LEGAL_CATEGORIES
});
store.runSaga([
    _uploadListFile,
    _uploadPartial,
]);

export default store;